import { DEFAULT_LIST_PAGE_SIZE } from 'src/util/constants';

/**
 * Returns first-page reset variables for retrying a paginated list route query
 * that accepts `$count: Int` and `$cursor: String` (`PropertyListRoute`,
 * `PortfolioListRoute`, `AdminCommunityListRoute`).
 * The cursor is omitted so Relay fetches the first page fresh, and `count`
 * matches the `DEFAULT_LIST_PAGE_SIZE` initial load set by `prepareVariables`
 * in `src/routes/index.jsx`. Returning an object (not `null`) keeps the
 * boundary retry button enabled.
 * @returns {{ count: number }} First-page reset variables.
 */
function getFirstPageRetryVariables() {
  return { count: DEFAULT_LIST_PAGE_SIZE };
}

export default getFirstPageRetryVariables;
